import {Country} from "../types/Country";

export const getPriceUnit = (country: Country) => (country === Country.POLAND ? "zł" : "eur");
import {Country} from "../types/Country";

export const getPriceUnit = (country: Country) => (country === Country.POLAND ? "zł" : "eur");
